var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.editionId)?_c('ezine-editions-settings',{attrs:{"edition-id":_vm.editionId},on:{"change-edition":function($event){_vm.editionId = $event}}}):_c('ezine-editions-index',{on:{"change-edition":function($event){_vm.editionId = $event}}})}
var staticRenderFns = []

export { render, staticRenderFns }